import { useEffect, useRef } from "react";
import { cherryPickState } from "@cede/utils";
import { useCedeStore } from "./useCedeStore";
import { useParamsForms } from "./useParamsForms/useParamsForms";
import { detectCedeProvider, CedeProvider } from "@cedelabs/providers/src";

/**
 * @description It manages all the logic necessary to setup the app
 *
 * TODO: Use an unified hook to detect the cede provider
 */
export const useSetupApp = () => {
  const prefillValueForAllForms = useParamsForms((state) => state.prefillValueForAllForms);
  const { setVaults, setProvider, activeVault } = useCedeStore(
    cherryPickState(["setVaults", "setProvider", "activeVault"]),
  );
  // Cede.store provider fires the unlock event continually when the user is connected so
  // we need to prevent the vaults to be updated more than once
  const shouldUpdateVaults = useRef(true);

  useEffect(() => {
    detectCedeProvider().then((provider) => {
      if (provider instanceof CedeProvider) {
        setProvider(provider);

        provider.on("accountsChanged", () => {
          if (!shouldUpdateVaults.current) return;
          const providerVaults = provider.getVaultPreviews();
          if (providerVaults) {
            setVaults(providerVaults);
            shouldUpdateVaults.current = false;
          }
        });

        provider.on("lock", () => {
          setVaults([]);
        });
      }
    });

    return () => {
      detectCedeProvider().then((provider) => {
        if (provider instanceof CedeProvider) {
          provider.removeAllListeners();
        }
      });
    };
  }, []);

  useEffect(() => {
    if (activeVault) {
      prefillValueForAllForms("vaultId", activeVault.id);
    }
  }, [activeVault]);
};
